import { commitMutation, graphql } from 'react-relay';

import environment from 'src/util/environment';

const mutation = graphql`
  mutation CloseNominatedTradeMutation($uuid: ID!) {
    closeNominatedTrade(uuid: $uuid) {
      id
      uuid
      closedAt
      closedBy {
        uuid
        email
        givenName
        familyName
      }
    }
  }
`;

/**
 * Close nominated trade mutation.
 * @param {object} tradeRuleIdSet id and UUID of the trade rule to be closed.
 * @param {Function} onCompleted Function to call on success.
 * @param {Function} onError Function to call on error.
 * @param {object} formatMessage i18n object
 */
const CloseNominatedTradeMutation = (tradeRuleIdSet, onCompleted, onError, formatMessage) => {
  const { id, uuid } = tradeRuleIdSet;
  commitMutation(
    environment,
    {
      mutation,
      variables: { uuid },
      onCompleted: (response) => { onCompleted(response, formatMessage); },
      onError,
      updater: (store) => {
        // Get the current trade rule record from the store.
        const ruleProxy = store.get(id);
        if (!ruleProxy) {
          if (process.env.NODE_ENV !== 'production') {
            console.error(`CloseNominatedTradeMutation: record ${id} not found in store.`);
          }
          return;
        }
        ruleProxy.setValue('TRADE_RULE_STATE_CLOSED', 'state');
      },
    },
  );
};

export default CloseNominatedTradeMutation;
